<template>
  <div id="GuaranteeReport">
    <loading v-if="loadingRender"></loading>
    <panel Title="گزارش ضمانت ها" Des="از طریق این فرم میتوانید گزارشی از ضمانت های خود را مشاهده نمائید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="card p-3 m-3 border rounded Netpa-Shadow w-100" id="Date">
        <div class="row">
          <span class="badge badge-light w-100 p-2 m-2">لطفا نوع ضمانت خود را انتخاب نمایید</span>
        </div>
        <div class="row">
          <div class="col-md-4 col-12 mt-2 text-right">
            <small>انتخاب نوع ضمانت</small>
            <select name="cmbGrp10" id="cmbGrp10" class="form-control Pointer" v-model="ResultcmbGrp10">
              <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
              <option selected value="-1">-- انتخاب نوع ضمانت --</option>
              <option v-for="item in this.ListModelcmbGrp10" :key="item.id" :value="item.id">
                <span>{{ item.name }} </span>
              </option>
            </select>
          </div>
          <div class="col-md-4 col-12 mt-2 text-right">
            <small>فیلتر تسهیلات</small>
            <select name="cmbVam" id="cmbVam" class="form-control Pointer">
              <option selected="selected" value="1">تمام ضمانت ها</option>
              <option value="2">تسهیلات دارای مانده</option>
              <option value="3">تسهیلات معوق</option>
            </select>
          </div>
          <div class="col-md-2 col-12 mt-3">
            <input
              type="button"
              name=""
              value="جستجو"
              class="btn btn-success mt-2 w-100"
              @click="
                GetReport()
                $ResetTimer()
              "
            />
          </div>
        </div>
      </div>
    </div>
    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>
<script>
import panel from '../Tools/NetPa/Panel.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  data() {
    return {
      DataAxios_cmbGrp10: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'SelCombo',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Zemanat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Zemantha',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModelcmbGrp10: null,
      IsLoad: false,
      ResultcmbGrp10: null,
      ResultcmbZemanat: null,
      ListModelZemanat: null,
      rows: [],
      listData: null,
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'شماره تسهیلات',
          name: 'vCode',
        },
        {
          label: 'مشخصات',
          name: 'familyNameVamGirande',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'تعداد قسط',
          name: 'tedadGhestVam',
        },
        {
          label: 'مانده تسهیلات',
          name: 'mande',
        },
        {
          label: 'مبلغ قسط تسهیلات',
          name: 'mablaghGhestVam',
        },
        {
          label: 'تعداد معوقات',
          name: 'countMoavaghe',
        },
        {
          label: 'توضیحات',
          name: 'sharh',
        },
        {
          label: 'نوع',
          name: 'cmbName',
        },
        {
          label: 'تاریخ آخرین قسط ',
          name: 'tarixLastGhest',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
    }
  },
  components: {
    panel,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData()
    formData.append('GrpId', 10)
    this.DataAxios_cmbGrp10.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbGrp10).then((data) => {
      this.IsLoad = true
      if(this.$session.get('CustCode') == 868){
        let list=[];
        data.forEach(el => {
          if(el.id==4163 || el.id==4031 || el.id==4192){
            list.push(el)
          }
        });
        this.ListModelcmbGrp10 = list
      }
      else{
        this.ListModelcmbGrp10 = data
      }
      this.ResultcmbGrp10 = data[0].id
    })
  },
  methods: {
    GetReport() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaIdPas', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('CmbID', this.ResultcmbGrp10 == -1 ? null : this.ResultcmbGrp10)
      this.DataAxios_Zemanat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_Zemanat).then((data) => {
        var cmbVam = document.getElementById('cmbVam')

        switch (cmbVam.options[cmbVam.selectedIndex].value) {
          case '1':
            this.listData = data.filter((x) => x)
            break
          case '2':
            this.listData = data.filter((x) => x.mande > 0)
            break
          case '3':
            this.listData = data.filter((x) => x.countMoavaghe > 0)
            break
          default:
            break
        }
        console.warn(this.listData)

        if (this.listData.length) {
          this.rows = this.$FormatMablaghGrid(this.listData)
          this.loadingRender = false
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
          this.config.pagination = false
          this.rows = []
          this.loadingRender = false
        }
      })
    },
  },
}
</script>
<style scoped></style>
